// import React from 'react';
import styles from './Promo.module.scss';
import SliderMission from '../../universal_components/Slider-mission/SliderMission';

// import textLogo from '../../../images/logo-text--dark.svg';
import { Link } from 'react-router-dom';
import NewsBlock from './NewsBlock';
import LogoBig from '../../../images/logo-big.svg';
import { isMobile } from 'react-device-detect';

const Promo = () => {
  return (
    <section className={styles.promo}>
      <div className={styles.background}>
        <SliderMission />
      </div>

      <Link to="/" className={styles.logo}>
        {/* <img src={textLogo} alt="logo" width="197" height="109" /> */}
        <img src={LogoBig} alt="logo" width="197" height="250" className={styles.logo} />
      </Link>
      {isMobile && <NewsBlock />}
    </section>
  );
};

export default Promo;
